import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import { FieldCheckbox, FieldDate, FieldImage, FieldInput, FieldSelect, FieldTextArea } from 'elements';
import FieldIcon from './FieldIcon';
class Field extends Component {
    renderField() {
        const { field, onChange } = this.props;
        const value = field.value || '';
        // console.log('Field - render - field: ', field)
        // console.log('Field - render - field.value: ', field.value)
        // console.log('Field - render - field.type: ', field.type)
        const required = (field.rules && field.rules.isRequired) || false;
        switch (field.type) {
            case FieldType.Text:
            case FieldType.Number:
            case FieldType.Password:
                return (React.createElement(FieldInput, { type: field.type, name: field.name, column: field.column, value: value, required: required, onChange: onChange }));
            case FieldType.TextArea:
                return (React.createElement(FieldTextArea, { type: field.type, name: field.name, column: field.column, value: value, required: required, onChange: onChange }));
            case FieldType.Checkbox:
                return (React.createElement(FieldCheckbox, { type: field.type, name: field.name, column: field.column, value: value, required: required, onChange: onChange }));
            case FieldType.Image:
                return (React.createElement(FieldImage, { name: field.name, column: field.column, value: value, footer: field.footer, accept: field.accept, onChange: onChange }));
            case FieldType.Select:
                return field.options ? (React.createElement(FieldSelect, { name: field.name, column: field.column, value: value, options: field.options, placeholder: field.placeholder, required: required, onChange: onChange })) : null;
            case FieldType.Date:
                return (React.createElement(FieldDate, { name: field.name, column: field.column, date: value, required: required, onChange: onChange }));
            case FieldType.DateTime:
                return (React.createElement(FieldDate, { name: field.name, column: field.column, date: value, withTime: true, required: required, onChange: onChange }));
            case FieldType.Icon:
                return (React.createElement(FieldIcon, { icon: value, icons: field.icons, onChange: onChange }));
            default:
                return null;
        }
    }
    render() {
        const { field } = this.props;
        return React.createElement(Wrapper, { size: field.size }, this.renderField());
    }
}
export default Field;
export const FieldType = {
    Checkbox: 'checkbox',
    Date: 'date',
    DateTime: 'dateTime',
    Icon: 'icon',
    Image: 'image',
    Number: 'number',
    Password: 'password',
    Select: 'select',
    Text: 'text',
    TextArea: 'textarea',
    MultiSelect: 'multiSelect'
};
const Wrapper = cxs('div')(({ size }) => ({
    padding: '0.1px',
    /*[mediaQueries.desktop]: {*/
    display: 'flex',
    flex: `1 1 ${(size || 10) * 10}%`,
    alignItems: 'flex-end',
    '> div': {
        flex: 1
    }
    /*} as CSSProperties*/
}));
Wrapper.propTypes = {
    size: PropTypes.number
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/Field.tsx
// module id = 160
// module chunks = 0